import React from 'react'

const ExportIcons = ({ style = {}, ...props }) => {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={style}
      {...props}>
      <title>export-icons</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g id="export-icons" transform="translate(0.000000, 1.000000)">
          <path
            d="M17.5,0.25 L17.5,10.179 L7.804,10.871 C7.164,10.917 6.936,10.996 6.707,11.132 C6.48128825,11.2654575 6.29896965,11.4613198 6.182,11.696 C6.062,11.934 6,12.167 6,12.809 L6,16.192 C6,16.833 6.063,17.066 6.182,17.304 C6.302,17.542 6.479,17.731 6.707,17.868 C6.936,18.004 7.164,18.083 7.804,18.128 L17.5,18.821 L17.5,27.75 L4.683,26.468 C3.009,26.301 2.417,26.081 1.824,25.712 C1.23898044,25.3514915 0.768656756,24.8319157 0.468,24.214 C0.16,23.587 0,22.976 0,21.294 L0,6.706 C0,5.023 0.16,4.412 0.468,3.786 C0.768344079,3.16734831 1.23869579,2.64704774 1.824,2.286 C2.417,1.918 3.009,1.698 4.684,1.531 L17.5,0.25 Z"
            id="Path"
            fillOpacity="0.07"
            fill="#16A5F3"
            fillRule="nonzero"
          />
          <path
            d="M16.636,0 L4.492,1.553 C2.49541172,1.80863666 0.999804182,3.50811281 1,5.521 L1,22.479 C0.999804182,24.4918872 2.49541172,26.1913633 4.492,26.447 L16.636,28"
            id="Path"
            stroke="#16A5F3"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11,13.431 L26.5,13.001 C27.0337726,12.9812273 27.5356827,13.254715 27.8084407,13.7139613 C28.0811988,14.1732076 28.0811988,14.7447924 27.8084407,15.2040387 C27.5356827,15.663285 27.0337726,15.9367727 26.5,15.917 L11,15.487 C10.4322513,15.487 9.972,15.0267487 9.972,14.459 C9.972,13.8912513 10.4322513,13.431 11,13.431 L11,13.431 Z"
            id="Path"
            fill="#16A5F3"
          />
          <path
            d="M29.07,14.414 C29.0706496,14.6791385 28.9655566,14.9335931 28.778,15.121 L21.121,22.778 C20.7286211,23.1569722 20.1049152,23.1515524 19.7191814,22.7658186 C19.3334476,22.3800848 19.3280278,21.7563789 19.707,21.364 L26.657,14.414 L19.707,7.464 C19.4470434,7.21292553 19.3427874,6.84112211 19.4343028,6.49149268 C19.5258183,6.14186324 19.7988632,5.86881828 20.1484927,5.77730284 C20.4981221,5.6857874 20.8699255,5.79004342 21.121,6.05 L28.778,13.707 C28.9658296,13.8943053 29.071274,14.1487395 29.0710005,14.414 L29.07,14.414 Z"
            id="Path"
            fill="#16A5F3"
          />
        </g>
      </g>
    </svg>
  )
}

export default ExportIcons
